import type { ExperimentConfig } from '../@types'

// The activity-female-tai-chi-walking-v2-al arm was rolled out in DEV-35150 (the +20% override now
// lives in the base paywall), so only female is still served as an experiment here.
const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_ml_price_prediction_high_wtp_i2_2~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_high_wtp_i2_2/f'),
			},
		},
	},
]

export default config
